import React, { useEffect } from 'react';

import {
  Card,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import ScheduleIcon from '@material-ui/icons/Schedule';

import CardTitle from '../../../common/card/CardTitle';
import { useGetWorkflowVersions } from '../Workflow.hooks';
import { WorkflowDto, WorkflowVersion } from '../Workflow.interface';
import { formatDate } from '../../../common/formatter';
import UserLink from '../../users/components/UserLink';

export interface WorkflowVersionCardProps {
  workflow: WorkflowDto;
}

const WorkflowVersionCard: React.FC<WorkflowVersionCardProps> = ({
  workflow
}) => {
  const { workflowVersions, isLoading, get } = useGetWorkflowVersions(
    workflow.id
  );

  useEffect(() => {
    get(); // refresh if training object is updated
  }, [get, workflow]);

  return (
    <Card>
      <CardTitle>
        <ScheduleIcon />
        Workflow Versions
      </CardTitle>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Version</TableCell>
              <TableCell>Published</TableCell>
              <TableCell>Employee</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3} padding='none'>
                  <LinearProgress />
                </TableCell>
              </TableRow>
            )}
            {workflowVersions && workflowVersions.length > 0 ? (
              workflowVersions.map((workflowVersion: WorkflowVersion) => (
                <TableRow key={workflowVersion.id} hover>
                  <TableCell>{workflowVersion.version}</TableCell>
                  <TableCell>{formatDate(workflowVersion.created)}</TableCell>
                  <TableCell>
                    <UserLink
                      type='name'
                      disableLink={true}
                      user={workflowVersion.createdBy}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3}>No approved workflow versions</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default WorkflowVersionCard;
